import React, { useState, useContext } from "react";
import { ProjectContext } from "../../App.js";
import ProjectBarChart from "./ProjectBarChart.js";
import BarChartReport from "./BarChartReport.js";
import ActualVsSelling from "./ActualVsSelling.js";
import UsersReportPage from "./UsersReportPage.js";

const TimesheetBarChart = () => {
  const { isNavBarOpen } = useContext(ProjectContext);
  const [activeTab, setActiveTab] = useState("productive");
  const [activeChart, setActiveChart] = useState(1);
  return (
    <div
      className={
        isNavBarOpen ? "report-main-container" : "report-main-container-close"
      }
    >
      {/* Header with Clickable Tabs */}
      <div className="report-header-con">
        <h3
          onClick={() => setActiveTab("productive")}
          style={{
            cursor: "pointer",
            color: activeTab === "productive" ? "#6200ee" : "black",
            backgroundColor: "transparent",
          }}
        >
          Productive Vs Non Productive
        </h3>
        <h3
          onClick={() => setActiveTab("available")}
          style={{
            cursor: "pointer",
            color: activeTab === "available" ? "#6200ee" : "black",
            backgroundColor: "transparent",
          }}
        >
          Available Vs Sold
        </h3>
        <h3
          onClick={() => setActiveTab("user")}
          style={{
            cursor: "pointer",
            color: activeTab === "user" ? "#6200ee" : "black",
            backgroundColor: "transparent",
          }}
        >
          User Report
        </h3>
      </div>

      {/* Conditionally Rendering Components Based on Active Tab */}
      <div className="active-tab-con">
        {activeTab === "productive" && <ProjectBarChart />}
        {activeTab === "comparison" && <BarChartReport />}
        {activeTab === "available" && (
          <div className="actual-selling-con">
            <div className="chart1-2-con">
              <h3
                style={{
                  cursor: "pointer",
                  color: activeChart === 1 ? "#6200ee" : "black",
                  margin: "0",
                }}
                onClick={() => setActiveChart(1)}
              >
                Chart 1
              </h3>
              <h3
                style={{
                  cursor: "pointer",
                  color: activeChart === 2 ? "#6200ee" : "black",
                  margin: "0",
                }}
                onClick={() => setActiveChart(2)}
              >
                Chart 2
              </h3>
            </div>
            {activeChart === 1 && <BarChartReport />}{" "}
            {activeChart === 2 && <ActualVsSelling />}
          </div>
        )}
        {activeTab === "user" && <UsersReportPage />}
      </div>
    </div>
  );
};

export default TimesheetBarChart;
